export const HomePageLinks = [
  {
    Heading: 'Personal Information',
    Description: 'View your personal details',
    Link: '/personalinfo',
    Image: '/images/home_personal_info.png',
  },
  {
    Heading: 'Beneficiaries',
    Description: "Update your beneficiaries through easy management of elected individual's details and allocated amounts",
    Link: '/beneficiaries',
    Image: '/images/home_beneficiaries.png',
  },
  {
    Heading: 'Accounts and loans',
    Description: 'View your short-term, personal and capital loans. Track transactions and request transfers between accounts',
    Link: '/accountsandloans',
    Image: '/images/home_accounts_loans.png',
  },
  {
    Heading: 'Documents',
    Description: 'View your personal details',
    Link: '/documents/taxstatements',
    Image: '/images/home_documents.png',
  },
  {
    Heading: 'Partner Plan',
    Description: 'Create and track your Partner plan throughout the year with steps in place to guide your progress with your Counselling Partner',
    Link: '/partnerplans',
    Image: '/images/home_plan.png',
  },
  {
    Heading: 'Partner Hub',
    Description: 'Home to all the key documents and reports that you need to navigate your Deloitte Partnership Journey and understand your obligations as a Partner',
    Link: 'https://ausdeloitte.sharepoint.com/sites/DOL-c-AU-PartnerHub',
    Image: '/images/home_team_site.png',
  },
  {
    Heading: 'Reports',
    Description: 'View your EPIC partner plan status reports here (currently for Business Unit Leaders only)',
    Link: '/reports',
    Image: '/images/home_reports.jpg',
  },
  {
    Heading: 'Admin center',
    Description: "We've made admin easy. Manage Partners personal info, upload tax statements, track Partner plans and run detailed reports",
    Link: '/admin/admincentre',
    Image: '/images/home_admin_centre.png',
  },
]



// WEBPACK FOOTER //
// ./src/constants/home.js